import { Box, BoxProps, styled } from '@mui/material';
import React, { ReactNode, useState } from 'react';
import { CloseOutlined } from '@mui/icons-material';

interface Props {
    open: boolean,
    children?: ReactNode
}

const StyledOverlayBackground = styled(Box)<BoxProps>(({theme}) => ({
    background: '#ffffffbb',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    "&.o-closed": {
        display: 'none'
    }
}));

const StyledOverlay = styled(Box)<BoxProps>(({theme}) => ({
    background: '#ffffff',
    boxShadow: '0px 0px 20px #515151;',
    borderRadius: '0.5em',
    margin: '0 auto',
    flexGrow : 1,
    width: '100%',
    height: '100%',
    maxWidth: '30em',
    maxHeight: '60%',
    textAlign: 'center',
    animation: 'createBox .25s',
    "&.o-closed": {
        display: 'none'
    },
    
    "@keyframes createBox": {
        "from": {
          transform: 'scale(0)'
        },
        "to": {
          transform: 'scale(1)'
        }
      }
}));

const Popup : React.FC<Props> = ({open, children}) => {
    const [overlayOpen, setOverlayOpen] = useState(open);
    return <StyledOverlayBackground className={`${!overlayOpen ? 'o-closed': ''}`}>
        <Box sx={{flexGrow : 1}}>
            <StyledOverlay className={`${!overlayOpen ? 'o-closed': ''}`}>
                <Box sx={{textAlign: 'right', padding: '0.5em 0.5em 0 0.5em'}}>
                    <CloseOutlined sx={{cursor: 'pointer'}} onClick={() => setOverlayOpen(false)} />
                </Box>
                <Box sx={{padding: '0 0.5em 0.5em 0.5em'}}>
                    {children}
                </Box>
            </StyledOverlay>
        </Box>
    </StyledOverlayBackground>
}

export default Popup;